import React, { useState } from 'react';
import clsx from 'clsx';
import { CustomModal } from 'components/CustomModal';

import { coinNames, coins } from 'helpers/constant';
import { getSymbol, getTokenImg, handleTokenImgError, shortenEsdt } from 'helpers/utils';
import { useInteraction } from 'Interaction';
import styles from './styles.module.scss';

export const TokenSelector = ({
    tokens,
    setToken,
    show,
    setShow
}: {
    tokens: any[],
    show: any,
    setShow: any,
    setToken: any
}) => {
    const { pairTokenInfos } = useInteraction();

    const [searchKey, setSearchKey] = useState('');
    
    return (
        <CustomModal
            show={show}
            onClose={setShow}
        >
            <input
                className={clsx(styles.search, 'flex-grow-1 my-4')}
                type='text'
                placeholder='Search Token'
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
            />
            <div className='d-flex justify-content-between mx-2'>
                <span className='text-white'>Token</span>
                <span className='text-white'>Balance</span>
            </div>
            <div className={styles.tokenList}>
                {
                    tokens.map((coinName, index) => {
                        if(!getSymbol(coinName).toLowerCase().includes(searchKey.toLowerCase())) return;

                        return (
                            <div
                                key={index}
                                className={clsx(styles.token, 'd-flex justify-content-between align-items-center m-2')}
                                onClick={() => {
                                    setToken(coinName);
                                    setShow(false);
                                }}
                            >
                                <div>
                                    <img src={getTokenImg(coinName)} onError={handleTokenImgError} alt={coinName} width={24} />
                                    <span className='text-white ml-2'>{ coinName }</span>
                                </div>
                                <div className='text-white'>{shortenEsdt(pairTokenInfos[coinName]?.balance)}</div>
                            </div>
                        );
                    })
                }
            </div>
        </CustomModal>
    );
};
